// import config from 'config';
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const creditService = {
    getCreditList,
    sellCredit,
    revokeCredit
};
axios.defaults.headers.common = authHeader();

function getCreditList(id) {
    return axios.get('/users/seller/assessment/credit/list/'+id+'/')
        .then(response => {
            return response;
        });
}

function sellCredit(data) {
    return axios.post('/users/seller/assessment/sell/credit/',data)
    .then(response => {
        return response;
    });
}

function revokeCredit(data) {
    return axios.post('/users/seller/assessment/revoke/credit/',data)
    .then(response => {
        return response;
    });
}




// WEBPACK FOOTER //
// ./src/_services/sellers/credits.service.js